import styled from 'styled-components';
import { FontAwesomeIcon } from '@vr/lib';
import { PageContainer as DefaultPageContainer } from '~/pages/common';
import devices from '~/styles/devices';
import { Title as TitleDefault } from '~/components/forms/common';

export const PageContainer = styled(DefaultPageContainer)`
  background: white;
  width: 100%;
  margin-top: 73px;
`;
export const FormContainer = styled.div`
  margin: -89px auto 0;
  padding: 40px 15px;
  background: white;
  border-radius: 15px;
  border: 1px solid ${({ theme }) => theme.colors.gray100};
  width: 100%;
  max-width: 643px;

  @media (min-width: ${devices.tablet}) {
    padding: 40px 32px;
  }
`;
export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 36px;

  @media (min-width: ${devices.tablet}) {
    justify-content: center;
  }
`;
export const BackIcon = styled(FontAwesomeIcon)`
  display: block;
  color: ${({ theme }) => theme.colors.gray400};
  margin-right: 17px;
  font-size: 20px;
  cursor: pointer;
  width: 21px;
  height: 21px;

  @media (min-width: ${devices.tablet}) {
    display: none;
  }
`;
export const Title = styled(TitleDefault)`
  margin-bottom: 0;
  color: ${({ theme }) => theme.colors.gray400};
`;
export const Description = styled.p`
  font-size: 0.9375rem;
  color: ${({ theme }) => theme.colors.gray400};
  text-align: center;
  line-height: 36px;
`;
export const Container = styled.div`
  padding: 21px;
  display: none;

  @media (min-width: ${devices.tablet}) {
    display: block;
  }
`;
